import { theme } from '@chakra-ui/react';
import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    display: 'inline-flex',
    appearance: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    position: 'relative',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    outline: 'none',
    py: '3',
    px: '6',
    fontWeight: 'bold',
    height: 'auto',
    border: '0.1',
    borderRadius: 'lg',
    // Stop box shadow from appearing on focus
    ':focus:not(:focus-visible)': {
      outline: 0,
      boxShadow: 'none',
    },
    // show box shadow on focus-visible while using keyboard
    ':focus': {
      outline: 0,
      boxShadow: '0 0 0 1px white, 0 0 0 3px #6691FF',
    },
  },
  sizes: {
    default: {
      fontSize: 'lg',
      height: '12',
    },
    small: {
      py: '2',
      px: '5',
      height: '9',
    },
  },
  variants: {
    primary: (props: StyleFunctionProps) => ({
      ...theme.components.Button.variants?.solid(props),
      bg: 'brand.solid-primary',
      color: 'misc.white-fix-primary',
      _hover: {
        bg: 'brand.solid-hover',
        _disabled: {
          bg: 'neutral.fill-subtle',
          color: 'neutral.fg-disabled',
        },
      },
      _active: {
        bg: 'brand.solid-hover',
      },
      _disabled: {
        bg: 'neutral.fill-subtle',
        color: 'neutral.fg-disabled',
      },
    }),
    secondary: (props: StyleFunctionProps) => ({
      ...theme.components.Button.variants?.outline(props),
      bg: 'neutral.bg-primary',
      color: 'neutral.fg-primary',
      borderColor: 'neutral.border-base',
      _hover: {
        color: 'brand.fg-primary',
        borderColor: 'brand.border-base',
        _disabled: {
          bg: 'neutral.bg-primary',
          color: 'neutral.fg-disabled',
          borderColor: 'neutral.border-base',
        },
      },
      _active: {
        bg: 'neutral.bg-tertiary',
        color: 'brand.fg-primary',
        borderColor: 'brand.border-base',
      },
      _disabled: {
        bg: 'neutral.bg-primary',
        color: 'neutral.fg-disabled',
      },
    }),
    negative: (props: StyleFunctionProps) => ({
      ...theme.components.Button.variants?.solid(props),
      bg: 'negative.solid-primary',
      borderColor: 'negative.solid-primary',
      color: 'misc.white-fix-primary',
      _hover: {
        bg: 'negative.solid-hover',
        borderColor: 'negative.solid-hover',
        _disabled: {
          bg: 'neutral.fill-subtle',
          color: 'neutral.fg-disabled',
          borderColor: 'transparent',
        },
      },
      _active: {
        bg: 'negative.fg-secondary',
        borderColor: 'negative.fg-secondary',
      },
      _disabled: {
        bg: 'neutral.fill-subtle',
        color: 'neutral.fg-disabled',
      },
    }),
  },
  defaultProps: {
    size: 'default',
    variant: 'primary',
  },
};
